import { Header } from "../../components/Header";

interface CheckoutLayoutProps {
  title: string;
  icon: React.ReactNode;
  message: string;
  description: string;
  actionButton: React.ReactNode;
  iconBgColor: string;
  iconTextColor: string;
  uxSimple?: boolean;
}

export function CheckoutLayout({ 
  title,
  icon,
  message,
  description,
  actionButton,
  iconBgColor,
  iconTextColor,
  uxSimple
}: CheckoutLayoutProps) {
  return (
    <div
      className={`min-h-screen flex flex-col ${uxSimple ? '' : 'bg-gray-50 dark:bg-gray-900'}`}
      style={uxSimple ? { backgroundColor: 'var(--color-bg-page)' } : undefined}
    >
      <Header title={title} showBack />
      
      <div className="flex-1 flex items-center justify-center p-4">
        <div
          className={`rounded-lg p-8 shadow-lg text-center max-w-md w-full ${uxSimple ? '' : 'bg-white dark:bg-gray-800'}`}
          style={uxSimple ? { backgroundColor: 'var(--color-bg-card)' } : undefined}
        >
          <div className={`w-20 h-20 ${iconBgColor} rounded-full flex items-center justify-center mx-auto mb-6`}>
            <div className={`${iconTextColor}`}>
              {icon}
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {message}
          </h2>
          
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            {description}
          </p>

          {actionButton}
        </div>
      </div>
    </div>
  );
}
